import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'

const useResetPassword = () => {
    const {getTokenWhenReady} = useAccessToken()
    const customApi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig

    const sendPasswordResetEmail = async (email) => {
        const token = await getTokenWhenReady()
        const apiName = 'reset-password'
        const endpointPath = '/'
        const parameters = {
            c_email: email
        }
        const response = await customApi.post(token, apiName, endpointPath, parameters, proxy)

        return response
    }

    return {
        sendPasswordResetEmail
    }
}

export default useResetPassword
